"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
var _popover = _interopRequireDefault(require("@amzn/meridian-tokens/component/popover"));
var _elevation = require("@amzn/meridian-tokens/base/elevation");
var _theme = require("../theme");
var _popoverBody = _interopRequireDefault(require("../_popover-body"));
var _popoverController = _interopRequireDefault(require("../_popover-controller"));
var _utils = require("../_popover-controller/utils");
var _token = require("./../_utils/token");
var _rtl = require("./../_utils/rtl");
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var maxWidth = _ref.maxWidth,
    vertical = _ref.vertical;
  return (0, _css.css)({
    maxWidth: maxWidth,
    overflowWrap: "break-word",
    padding: vertical ? "".concat(t("offsetWithArrow"), "px 0") : "0 ".concat(t("offsetWithArrow"), "px")
  });
}, ["maxWidth", "vertical"]);

/**
 * Add a tooltip to an element. A note on accessibility: tooltips should only be
 * added to elements that are focusable. This allows keyboard users to open the
 * tooltip by tabbing to the tooltip's anchor node. Otherwise keyboard users
 * would not be able to open the tooltip. This means that *tooltips should not
 * be anchored to disabled elements directly*, since disabled elements generally
 * can't be focused.
 */
var Tooltip = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Tooltip, _React$Component);
  var _super = _createSuper(Tooltip);
  function Tooltip() {
    var _this;
    (0, _classCallCheck2["default"])(this, Tooltip);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "hoverTooltipTimeout", undefined);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      hover: false,
      focus: false,
      closedByEscape: false,
      id: _this.props.id ? _this.props.id : (0, _uniqueId["default"])("tooltip-")
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "isOpen", function () {
      return _this.props.open === undefined ? !_this.state.closedByEscape && (_this.state.hover || _this.state.focus) : _this.props.open;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateTooltipRef", function (node) {
      if (node && node !== _this.tooltipRef) {
        _this.tooltipRef = node;
        _this.addEventListeners();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateAnchorNode", function (node) {
      if (node && node !== _this.anchorNode) {
        _this.anchorNode = node;
        // If the Tooltip is managing state internally then bind the event
        // listeners that trigger internal state changes
        if (_this.props.open === undefined) {
          _this.addEventListeners();
        }
        // If the Tooltip is supposed to be open then force an update so it
        // re-renders with the anchor node
        if (_this.isOpen()) {
          _this.forceUpdate();
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "addEventListeners", function () {
      // Remove any existing event listeners to ensure we don't accidentally stack
      // multiple listeners
      _this.removeEventListeners();
      if (_this.anchorNode && typeof _this.anchorNode.addEventListener === "function") {
        _this.anchorNode.addEventListener("mouseenter", _this.onMouseEnterAnchor);
        // NOTE: This *must* be bound using a native event listener because of a bug
        // in React: https://github.com/facebook/react/issues/4251
        _this.anchorNode.addEventListener("mouseleave", _this.onMouseLeaveAnchor);
        _this.anchorNode.addEventListener("focus", _this.onFocusAnchor, true);
        _this.anchorNode.addEventListener("blur", _this.onBlurAnchor, true);
        _this.anchorNode.addEventListener("keydown", _this.onKeyDownEscape);
      }
      if (_this.tooltipRef && typeof _this.tooltipRef.addEventListener === "function") {
        _this.tooltipRef.addEventListener("mouseenter", _this.onMouseEnterTooltip);
        _this.tooltipRef.addEventListener("mouseleave", _this.onMouseLeaveTooltip);
      }
      if (window && window.addEventListener) {
        window.addEventListener("keydown", _this.onKeyDownEscape);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "removeEventListeners", function () {
      if (_this.anchorNode && typeof _this.anchorNode.addEventListener === "function") {
        _this.anchorNode.removeEventListener("mouseenter", _this.onMouseEnterAnchor);
        _this.anchorNode.removeEventListener("mouseleave", _this.onMouseLeaveAnchor);
        _this.anchorNode.removeEventListener("focus", _this.onFocusAnchor, true);
        _this.anchorNode.removeEventListener("blur", _this.onBlurAnchor, true);
        _this.anchorNode.removeEventListener("keydown", _this.onKeyDownEscape);
      }
      if (_this.tooltipRef && typeof _this.tooltipRef.addEventListener === "function") {
        _this.tooltipRef.removeEventListener("mouseenter", _this.onMouseEnterTooltip);
        _this.tooltipRef.removeEventListener("mouseleave", _this.onMouseLeaveTooltip);
      }
      if (window && window.removeEventListener) {
        window.removeEventListener("keydown", _this.onKeyDownEscape);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnterAnchor", function () {
      if (_this.hoverTooltipTimeout) clearTimeout(_this.hoverTooltipTimeout);
      _this.setState({
        hover: true,
        closedByEscape: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseEnterTooltip", function () {
      if (_this.hoverTooltipTimeout) clearTimeout(_this.hoverTooltipTimeout);
      _this.setState({
        hover: true
      });
    });
    // If the user mouses out then close the tooltip even if the anchor is
    // focused. This keeps the tooltip from sticking open for mouse users after
    // they click on (and focus) the anchor. This won't affect keyboard and mobile
    // users who will never trigger the mouse leave.
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeaveAnchor", function () {
      if (_this.hoverTooltipTimeout) clearTimeout(_this.hoverTooltipTimeout);
      _this.hoverTooltipTimeout = setTimeout(function () {
        _this.setState({
          hover: false,
          focus: false
        });
      }, 10);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onMouseLeaveTooltip", function () {
      if (_this.hoverTooltipTimeout) clearTimeout(_this.hoverTooltipTimeout);
      _this.hoverTooltipTimeout = setTimeout(function () {
        _this.setState({
          hover: false,
          focus: false
        });
      }, 10);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFocusAnchor", function () {
      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
        anchorNode = _assertThisInitialize.anchorNode;
      // If a user has not set an id for accessibility
      // use our own auto-generated one
      try {
        if (!anchorNode.hasAttribute("aria-controls")) {
          anchorNode.setAttribute("aria-controls", _this.state.id);
        }
        if (!anchorNode.hasAttribute("aria-describedby")) {
          anchorNode.setAttribute("aria-describedby", _this.state.id);
        }
      } catch (_) {
        // Silent error
      }
      _this.setState({
        focus: true,
        closedByEscape: false
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onBlurAnchor", function () {
      return _this.setState({
        focus: false
      });
    });
    // Close the tooltip when the user presses Esc, if and only if
    // the tooltip is managing its own state and not using props.open.
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onKeyDownEscape", function (event) {
      if (_this.isOpen && event.key === "Escape") {
        _this.setState({
          closedByEscape: true
        });
      }
    });
    return _this;
  }
  (0, _createClass2["default"])(Tooltip, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If we're moving from state being managed via the `open` prop to state
      // being managed internally, bind the event listeners that trigger internal
      // state changes
      if (prevProps.open !== undefined && this.props.open === undefined) {
        this.addEventListeners();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        title = _this$props.title,
        maxWidth = _this$props.maxWidth,
        children = _this$props.children,
        delay = _this$props.delay;
      var position = (0, _rtl.getHorizontalDirection)(this.props.position);
      var anchorNode = this.anchorNode;
      var oppositePosition = (0, _utils.flipAlignment)(position);
      var vertical = position === "top" || position === "bottom";
      var passThroughProps = (0, _filterPropsByPrefix["default"])(this.props, ["data-", "aria-"]);
      var popover = /*#__PURE__*/_react["default"].createElement(_theme.Style, {
        tokens: _popover["default"],
        map: (0, _token.getTokenHelper)("popover"),
        key: "popover"
      }, function (t) {
        return /*#__PURE__*/_react["default"].createElement(_popoverController["default"], {
          open: _this2.isOpen(),
          anchorNode: anchorNode,
          anchorOrigin: vertical ? "".concat(position, " center") : "center ".concat(position),
          popoverOrigin: vertical ? "".concat(oppositePosition, " center") : "center ".concat(oppositePosition),
          shrinkToFit: false,
          delay: delay
        }, function (_ref2) {
          var popoverStyle = _ref2.popoverStyle,
            popoverOrigin = _ref2.popoverOrigin,
            anchorOrigin = _ref2.anchorOrigin,
            anchorRect = _ref2.anchorRect;
          return /*#__PURE__*/_react["default"].createElement(_popoverBody["default"], (0, _extends2["default"])({}, passThroughProps, {
            type: "fill",
            spacingInset: "300",
            zIndex: _elevation.elevationTooltip,
            className: "".concat(styles(t, {
              maxWidth: maxWidth,
              vertical: vertical
            }), " ").concat(popoverStyle),
            id: _this2.props.id ? _this2.props.id : (0, _uniqueId["default"])("tooltip-"),
            role: "tooltip",
            ref: _this2.updateTooltipRef,
            arrowOffsetFromEdge: t("offsetWithArrow")
          }, _popoverBody["default"].generateArrowProps({
            popoverOrigin: popoverOrigin,
            anchorOrigin: anchorOrigin,
            anchorRect: anchorRect
          })), title);
        });
      });
      var child = _react["default"].Children.only(children);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].cloneElement(child, {
        ref: this.updateAnchorNode
      }), popover);
    }
  }]);
  return Tooltip;
}(_react["default"].Component);
Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The element that the tooltip should reference.
   *
   * The tooltip will point at this element, and will be triggered when the
   * user hovers over this element or focuses on it.
   *
   * This element must accept a [ref](https://reactjs.org/docs/refs-and-the-dom.html),
   * and should be focuseable to ensure that the tooltip is accessible to keyboard
   * users.
   */
  children: _propTypes["default"].element.isRequired,
  /**
   * The position of the tooltip relative to the anchor element (provided via
   * `children`).
   *
   * Note that the tooltip may reposition itself to the opposite side of the
   * element if there is not enough screen space to display itself in the
   * position identified here.
   */
  position: _propTypes["default"].oneOf(["top", "end", "bottom", "start"]).isRequired,
  /**
   * The content shown in the tooltip.
   *
   * Plain strings are recommended. Use a node for text formatting or adding icons.
   * Do not put interactive elements in tooltip titles as they are inaccessible.
   */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * Within the Tooltip component, there are some aria- attributes that we set for ourselves,
   * in order to make sure the component is wired up in a way that makes it accessible
   * right out of the box. If you attempt to override the following property,
   * they'll be ignored:
   *
   * aria-labelledby
   */
  "aria-*": _propTypes["default"].string,
  /**
   * All props starting with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,
  /**
   * Set the delay in miliseconds before showing the Tooltip.
   *
   * The [W3 ARIA spec](https://w3c.github.io/aria/#tooltip) notes that a typical delay
   * is between 1-5 seconds (or 1000-5000 milisconds).
   */
  delay: _propTypes["default"].number,
  /**
   * Sets an `id` attribute on the component.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,
  /**
   * Set the maximum width of the tooltip using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  maxWidth: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  /**
   * If defined this will determine whether the tooltip is open or closed. If
   * omitted the tooltip will manage it's own state.
   *
   * Use this sparingly, in most cases the tooltip's internal state management
   * will correctly determine when it should open and close.
   */
  open: _propTypes["default"].bool
} : {};
Tooltip.defaultProps = {
  maxWidth: 300,
  delay: 0
};
var _default = Tooltip;
exports["default"] = _default;